import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SignUpSectionSignUp1 from '../components/sign-up/SignUpSectionSignUp1';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function SignUp() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <SignUpSectionSignUp1 />
    </React.Fragment>
  );
}

